import { createContent } from '@altify/utils';

export const taxInformationContent = createContent({
  en: {
    continue: 'Continue',
    confirmAndSubmit: 'Confirm & Submit',
    countryOfResidenceTitle: 'Add Country of Residence',
    addHomeAddressTitle: 'Add Home Address',
    countryOfTaxResidenceTitle: 'Add Country of Tax Residence',
    taxNumberTitle: 'Add Tax Number',
    reviewDetailsTitle: 'Review Details',
    editDetailsTitle: 'Edit Details',
    countryOfResidence: 'Country of Residence',
    countryOfTaxResidence: 'Country of Tax Residence',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    city: 'City',
    postCode: 'Post Code',
    addressLine1Required: 'Address Line 1 is required',
    addressLine1MaxLength: 'Address Line 1 must be at most 255 characters',
    cityRequired: 'City is required',
    cityMaxLength: 'City must be at most 255 characters',
    postCodeRequired: 'Post Code is required',
    postCodeMaxLength: 'Post Code must be at most 50 characters',
    taxResidenceInfo:
      'Your country of tax residence is the main country where you pay tax.',
    taxIdentificationNumber: 'Tax Identification Number (TIN)',
    taxIdentificationNumberInfo:
      'Your Tax Identification Number (TIN) is a unique number issued by your country’s tax authority to identify you for tax purposes.',
    taxIdentificationNumberIsRequired:
      'Tax Identification Number (TIN) is required',
    taxIdentificationNumberMaxLength:
      'Tax Identification Number (TIN) must be at most 50 characters',
    updateDetails: 'Update Details',
    unexpectedErrorOccurred: 'An unexpected error occurred. Please try again.',
  },
  de: {
    continue: 'Weiter',
    confirmAndSubmit: 'Bestätigen & Absenden',
    countryOfResidenceTitle: 'Wohnsitzland hinzufügen',
    countryOfTaxResidenceTitle: 'Wohnsitzland für Steuerzwecke hinzufügen',
    addHomeAddressTitle: 'Wohnadresse hinzufügen',
    taxNumberTitle: 'Steueridentifikationsnummer hinzufügen',
    reviewDetailsTitle: 'Details überprüfen',
    editDetailsTitle: 'Details bearbeiten',
    countryOfResidence: 'Wohnsitzland',
    countryOfTaxResidence: 'Wohnsitzland für Steuerzwecke',
    addressLine1: 'Adresszeile 1',
    addressLine2: 'Adresszeile 2',
    city: 'Stadt',
    postCode: 'Postleitzahl',
    addressLine1Required: 'Adresszeile 1 ist erforderlich',
    addressLine1MaxLength: 'Adresszeile 1 darf maximal 255 Zeichen lang sein',
    cityRequired: 'Stadt ist erforderlich',
    cityMaxLength: 'Stadt darf maximal 255 Zeichen lang sein',
    postCodeRequired: 'Postleitzahl ist erforderlich',
    postCodeMaxLength: 'Postleitzahl darf maximal 50 Zeichen lang sein',
    taxResidenceInfo:
      'Dein Wohnsitzland für Steuerzwecke ist das Hauptland, in dem Du Steuern zahlst.',
    taxIdentificationNumber: 'Steueridentifikationsnummer (TIN)',
    taxIdentificationNumberInfo:
      'Deine Steueridentifikationsnummer (TIN) ist eine eindeutige Nummer, die von der Steuerbehörde Deines Landes vergeben wird, um Dich für Steuerzwecke zu identifizieren.',
    taxIdentificationNumberIsRequired:
      'Steueridentifikationsnummer (TIN) ist erforderlich',
    taxIdentificationNumberMaxLength:
      'Steueridentifikationsnummer (TIN) darf maximal 50 Zeichen lang sein',
    updateDetails: 'Details aktualisieren',
    unexpectedErrorOccurred:
      'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
  },
});
